import { createSelector } from 'reselect';

const selectCategory = (state) => state.category;

const selectActiveCategories = createSelector(
	selectCategory,
	(category) => category?.actives
);

const selectSubCategories = createSelector(
	selectCategory,
	(category) => category?.subCategories
);

const selectCategoryRecommonded = createSelector(
	selectCategory,
	(category) => category?.recommoned_category
);

const selectDynamicAttributes = createSelector(
	selectCategory,
	(category) => category?.dynamicAttributes
);

const selectCategoriesTags = createSelector(
	selectCategory,
	(category) => category?.tags
);

const categorySelectors = {
	selectCategory,
	selectActiveCategories,
	selectSubCategories,
	selectDynamicAttributes,
	selectCategoriesTags,
	selectCategoryRecommonded,
};

export default categorySelectors;
